import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { PptAccessListParticipantService } from '../../services/wealthlane-customer-services/services/PptAccessListParticipantService';
import { Wealthlane_AdvisorApi_PptAccessListStatus } from '../../services/wealthlane-customer-services/models/Wealthlane_AdvisorApi_PptAccessListStatus';
import { type Wealthlane_Dtos_AdvisorApi_PptAccessListDto } from '../../services/wealthlane-customer-services/models/Wealthlane_Dtos_AdvisorApi_PptAccessListDto';

export type SetParticipantPptAccessStatusVariables = {
  id: string;
  status: Wealthlane_AdvisorApi_PptAccessListStatus;
};

const SUCCESS_MESSAGES: Record<Wealthlane_AdvisorApi_PptAccessListStatus, string> = {
  [Wealthlane_AdvisorApi_PptAccessListStatus._1]: 'Advisor access returned to pending.',
  [Wealthlane_AdvisorApi_PptAccessListStatus._2]: 'Advisor access granted successfully.',
  [Wealthlane_AdvisorApi_PptAccessListStatus._3]: 'Advisor access revoked successfully.',
};

const usePostSetParticipantPptAccessStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
): UseMutationResult<
  Wealthlane_Dtos_AdvisorApi_PptAccessListDto | undefined,
  unknown,
  SetParticipantPptAccessStatusVariables,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, status }) =>
      await handleRequest(
        PptAccessListParticipantService.postApiCustomerApiAppPptAccessListParticipantSetAccessStatus({
          id,
          status,
        }),
      ),
    {
      onSuccess: (_data, variables) => {
        toast.success(
          <ToastComponent label='Success' message={SUCCESS_MESSAGES[variables.status]} />,
        );
        void queryClient.invalidateQueries('getParticipantPptAccessList');
      },
      onError: (err) => {
        console.log('error', err);
      },
    },
  );
};

export default usePostSetParticipantPptAccessStatus;
